<template>
  <div class="settings">
    <app-redirect/>
  </div>
</template>

<script>
  import appRedirect from "../../../../components/appRedirect";
  export default {
    name: "src-pages-body-workstation-requests-edit-v1-mobile",
    components: {
      appRedirect
    },
  }
</script>
